import { Container, Divider } from "@material-ui/core";
import { Grid, Typography } from "@mui/material";
import axios from "axios";
import {
  ButtonGroupTop,
  CurrencyDisplay,
  CustomTable,
  DateRangePicker,
  ModalError,
  ModalSuccess,
  ModalWarning,
  Page,
  PrimaryButton,
  SelectInput,
  StatusChip,
} from "components";
import { HeaderTitle } from "layouts";
import { getTotalPage } from "lib";
import { debounce } from "lodash";
import moment from "moment-timezone";
import { Fragment, useCallback, useEffect, useState } from "react";
import { hardBaseUrl } from "services/urlConstant";
import { globalStyles } from "styles";
import {
  formatDate,
  formatPayloadDate,
  getErrors,
  wordCapitalize,
} from "utils";
import ModalPreviewUploadCCID from "../Components/ModalPreviewUploadCCID";
import ModalRemoteDirectory from "../Components/ModalRemoteDirectory";
import { statusCCID } from "../Components/Constant";

const UploadCCID = () => {
  const classes = globalStyles();
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const pageTitle = "Upload CCID";

  const [loadingPage, setLoadingPage] = useState(false);
  const [dataTable, setDataTable] = useState([]);
  const [queryParams, setQueryParams] = useState({
    page: 1,
    size: 10,
    start_date: null,
    end_date: null,
    dsp_id: 0,
  });
  const [tableTotalPage, setTableTotalPage] = useState(1);
  const [optionDsp, setOptionDsp] = useState([]);
  const [payload, setPayload] = useState([]);
  const [modalPreviewVisible, setModalPreviewVisible] = useState(false);
  const [modalPreviewPreload, setModalPreviewPreload] = useState(null);
  const [loadingModal, setLoadingModal] = useState(false);
  const [dataModal, setDataModal] = useState({});
  const [queryParamsModal, setQueryParamsModal] = useState({
    page: 1,
    size: 10,
    search: "",
  });
  const [tableTotalPageModal, setTableTotalPageModal] = useState(1);
  const [modalDirectoriesVisible, setModalDirectoriesVisible] = useState(false);
  const [selectedDSP, setSelectedDSP] = useState(null);

  const handleChangeQueryParams = (value, key) => {
    setQueryParams(currentState => ({
      ...currentState,
      ...(key !== "page" && { page: 1 }),
      [key]: value,
    }));
  };
  const handleChangeQueryParamsModal = (value, key) => {
    setQueryParamsModal(currentState => ({
      ...currentState,
      ...(key !== "page" && { page: 1 }),
      [key]: value,
    }));
  };
  const checkedAction = item => payload?.includes(item?.key);
  const handleCheckboxAction = (event, option) => {
    const { checked } = event.target;
    setPayload((currentState = []) => {
      if (checked) {
        return currentState.includes(option?.key)
          ? currentState
          : [...currentState, option?.key];
      }

      return currentState.filter(item => item !== option?.key);
    });
  };
  const handleUploadCCID = () => {
    ModalWarning("Are you sure want to upload this data?", "Upload CCID").then(
      res => res.isConfirmed && postUploadCCID()
    );
  };
  const handleChangeDSP = e => {
    const { value } = e?.target;
    handleChangeQueryParams(value, "dsp_id");
    setSelectedDSP(optionDsp?.find(item => item?.dsp_id === value));
  };
  const handleRetryCCID = item => {
    ModalWarning(
      "Are you sure want to retry upload this data?",
      "Retry CCID"
    ).then(res => res.isConfirmed && postRetryCCID(item));
  };

  const getOptionDsp = async () => {
    try {
      const res = await axios.get(
        `${hardBaseUrl}/ccid-upload/list-dsp-upload`,
        {
          headers,
        }
      );
      setOptionDsp(res?.data?.data);
    } catch (error) {
      ModalError(getErrors(error?.response));
    }
  };
  const getDataTable = async () => {
    const { start_date, end_date, ...rest } = queryParams;
    try {
      setLoadingPage(true);
      const res = await axios.get(`${hardBaseUrl}/ccid-upload/list-period`, {
        headers,
        params: {
          ...rest,
          start_date: formatPayloadDate(start_date),
          end_date: formatPayloadDate(end_date),
        },
      });
      const { data, meta } = res?.data;
      setDataTable(data || []);
      const pageCount = getTotalPage(meta?.total, queryParams?.size);
      setTableTotalPage(pageCount || 1);
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };
  const getDataTableModal = async () => {
    try {
      setLoadingModal(true);
      const res = await axios.get(
        `${hardBaseUrl}/ccid-upload/list-period/${modalPreviewPreload?.key}`,
        {
          headers,
          params: queryParamsModal,
        }
      );
      const { data, meta } = res?.data;
      setDataModal(data);
      const pageCount = getTotalPage(meta?.total, queryParamsModal?.size);
      setTableTotalPageModal(pageCount || 1);
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingModal(false);
    }
  };
  const debounceDataTableModal = useCallback(
    debounce(() => {
      getDataTableModal();
    }, 500),
    [queryParamsModal]
  );
  const postUploadCCID = async () => {
    const modifiedPayload = {
      sftp_config_id: selectedDSP?.config_id,
      keys: payload,
    };
    try {
      setLoadingPage(true);
      const res = await axios.post(
        `${hardBaseUrl}/ccid-upload/process`,
        modifiedPayload,
        { headers }
      );
      ModalSuccess(res?.data?.message || "Successfully upload CCID").then(() =>
        getDataTable()
      );
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };
  const postRetryCCID = async item => {
    try {
      setLoadingPage(true);
      const res = await axios.post(
        `${hardBaseUrl}/ccid-upload/retry/${item?.process_id}`,
        {},
        { headers }
      );
      ModalSuccess(
        res?.data?.message || "Successfully retry upload CCID"
      ).then(() => getDataTable());
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };

  useEffect(() => {
    getOptionDsp();
  }, []);
  useEffect(() => {
    if (queryParams?.dsp_id) {
      getDataTable();
    } else {
      setDataTable([]);
    }
  }, [queryParams]);
  useEffect(() => {
    if (modalPreviewVisible) {
      const isSearching = Boolean(queryParamsModal?.search);
      if (isSearching) {
        debounceDataTableModal();
        return () => {
          debounceDataTableModal.cancel();
        };
      } else {
        getDataTableModal();
      }
    } else {
      setModalPreviewPreload(null);
    }
  }, [queryParamsModal, debounceDataTableModal, modalPreviewVisible]);

  return (
    <Page className={classes.root} title={pageTitle}>
      <Container maxWidth={false}>
        <HeaderTitle
          title="CCID"
          breadcrumbData={breadcrumbData({ pageTitle })}
        />
        <ButtonGroupTop />
        <Divider className={classes.flatDivider} />
        <Grid container justifyContent="space-between" my={2}>
          <Grid item>
            <Grid container columnSpacing={2} alignItems="center">
              <Grid item>
                <SelectInput
                  label="DSP"
                  options={optionDsp}
                  optionKey="dsp_id"
                  optionLabel="dsp_config_name"
                  value={queryParams?.dsp_id || ""}
                  onChange={handleChangeDSP}
                  placeholder="Select DSP"
                  width={200}
                />
              </Grid>
              {!!queryParams?.dsp_id && (
                <Grid item>
                  <DateRangePicker
                    label="Data Period"
                    startDate={queryParams?.start_date}
                    endDate={queryParams?.end_date}
                    handleChangeStartDate={value =>
                      handleChangeQueryParams(value, "start_date")
                    }
                    handleChangeEndDate={value =>
                      handleChangeQueryParams(value, "end_date")
                    }
                    width="315px"
                    startMinDate={moment("2010-01", "YYYY-MM")}
                    endMaxDate={moment().add(10, "years")}
                    clear
                  />
                </Grid>
              )}
            </Grid>
          </Grid>
          {!!queryParams?.dsp_id && (
            <Fragment>
              <Grid item>
                <Grid container columnSpacing={2}>
                  <Grid item>
                    <PrimaryButton
                      label="Remote Directory"
                      onClick={() => setModalDirectoriesVisible(true)}
                    />
                  </Grid>
                  <Grid item>
                    <PrimaryButton
                      label="Upload CCID"
                      onClick={handleUploadCCID}
                      disabled={!payload?.length}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Fragment>
          )}
        </Grid>
        {queryParams?.dsp_id ? (
          <CustomTable
            isLoading={loadingPage}
            columnTable={columnTable}
            data={dataTable}
            page={queryParams?.page}
            pageSize={queryParams?.size}
            pageCount={tableTotalPage}
            handleChangePage={(_, page) =>
              handleChangeQueryParams(page, "page")
            }
            handleChangePageSize={e =>
              handleChangeQueryParams(e?.target?.value, "size")
            }
            isHaveAction
            isHaveCheckbox
            tooltipView="View"
            handleView={item => {
              setModalPreviewVisible(true);
              setModalPreviewPreload(item);
            }}
            tooltipRestore="Retry"
            disabledRestore={item => item?.status !== "error"}
            handleRestore={handleRetryCCID}
            disabledCheckbox={item => item?.status === "sent"}
            checked={checkedAction}
            handleCheckbox={handleCheckboxAction}
          />
        ) : (
          <Typography
            fontSize={18}
            fontWeight={400}
            color="#687083"
            align="center"
          >
            Select DSP first to process the data
          </Typography>
        )}
        {modalPreviewVisible && (
          <ModalPreviewUploadCCID
            open={modalPreviewVisible}
            onClose={() => setModalPreviewVisible(false)}
            queryParamsModal={queryParamsModal}
            handleChangeQueryParamsModal={handleChangeQueryParamsModal}
            isLoading={loadingModal}
            dataModal={dataModal}
            pageCount={tableTotalPageModal}
          />
        )}
        {modalDirectoriesVisible && (
          <ModalRemoteDirectory
            open={modalDirectoriesVisible}
            onClose={() => setModalDirectoriesVisible(false)}
            dsp={selectedDSP}
          />
        )}
      </Container>
    </Page>
  );
};

const breadcrumbData = ({ pageTitle }) => [
  {
    label: "Home",
    link: "/admin/dashboard",
  },
  {
    label: "CCID",
    link: "/admin/upload-ccid",
  },
  {
    label: pageTitle,
    active: true,
  },
];
const columnTable = [
  {
    name: "dsp_name",
    title: "DSP",
  },
  {
    name: "all",
    title: "Data Period",
    renderText: date =>
      `${formatDate(date?.start_date)} - ${formatDate(date?.end_date)}`,
  },
  {
    name: "sequence",
    title: "Generate No",
    headerAlign: "right",
    renderText: item => <CurrencyDisplay value={item} />,
  },
  {
    name: "status",
    title: "Status",
    renderText: status => (
      <StatusChip
        label={statusCCID?.[status]?.label ?? wordCapitalize(status)}
        type={statusCCID?.[status]?.type ?? "default"}
      />
    ),
  },
];

export default UploadCCID;
